"use client";

// Tiny client-only component embedded in the public homepage. Fires
// the site_visit beacon once per session per UTC day (server enforces
// the dedup). Renders nothing.

import { useEffect } from "react";
import { fireBeacon } from "@/lib/analytics/beacon";

export function HomePageBeacon() {
  useEffect(() => {
    fireBeacon("site_visit");
  }, []);
  return null;
}
